<template>
  <div id="info">
    <p class="infoHeader">Notification List({{page.pagingTotal}})</p>
    <a-row type="flex" justify="space-between">
      <a-col></a-col>
      <a-col>
        <a-pagination
              size="small"
              :total="page.pagingTotal"
              v-model="page.currentVal"
              :pageSize.sync="page.pagingSize"
              @change="tableChangePage"
              @showSizeChange="onShowSizeChange"
              showSizeChanger

      />
      </a-col>
    </a-row>

    <vxe-table
            border
            resizable
            :data.sync="infoTable"
            highlight-hover-row
            stripe
            size="mini"
            :max-height="600"
            :loading="loading"
            @cell-click="cellClickEvent"
    >
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="refNum"
              title="Ref Num"
      >
      </vxe-table-column>
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="refType"
              title="Ref Type"
      >
      </vxe-table-column>
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="msgType"
              title="Msg Type"
      >
      </vxe-table-column>
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="status"
              title="Status"
      >
      </vxe-table-column>
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="readStatus"
              title="Is Read"
      >
        <template v-slot="{ row }">
         <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">{{row.readStatus ? 'Yes' : 'No'}}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
              show-header-overflow="ellipsis" show-overflow="ellipsis"
              field="creatTime"
              title="Create Time"
      >
      </vxe-table-column>
    </vxe-table>
    <a-modal
            title="Notification"
            v-model="ificationvis"
            width="50%"
    >
      <a-row>
        <div class="infoDetail">
          <span class="infoDetail_L">Subject: </span>
          <span class="infoDetail_R">{{detailHeader.subject}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">Ref Type : </span>
          <span class="infoDetail_R">{{detailHeader.refType}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">Ref Num: </span>
          <span class="infoDetail_R">{{detailHeader.refNum}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">Start Time: </span>
          <span class="infoDetail_R">{{detailHeader.startTime}}</span>
        </div>
        <div class="infoDetail">
          <span class="infoDetail_L">Complete Time: </span>
          <span class="infoDetail_R">{{detailHeader.completeTime}}</span>
        </div>
      </a-row>
      <a-divider />
      <div class="infodetailContext">
        <div v-html="detailHeader.content"></div>
      </div>
      <a-divider />
      <vxe-table
              border
              resizable
              :data.sync="detailTable"
              highlight-hover-row
              stripe
              size="mini"
              :max-height="300"
      >
        <vxe-table-column
                show-header-overflow="ellipsis" show-overflow="ellipsis"
                field="userAccount"
                title="Receiver"
        >
        </vxe-table-column>
        <vxe-table-column
                show-header-overflow="ellipsis" show-overflow="ellipsis"
                field="readTime"
                title="Status"
        >
          <template v-slot="{ row }">
           <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">{{ row.readTime == null ? 'No': 'Yes' }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
                show-header-overflow="ellipsis" show-overflow="ellipsis"
                field="readTime"
                title="Read Time"
        >
        </vxe-table-column>
      </vxe-table>
    </a-modal>
  </div>
</template>
<script>
  import ajax from '../../api/ajax'
  import api from '../../api/url'
  import moment from 'moment'
  import cookie from '../../api/cookie'
  export default{
      data(){
          return {
              loading: false,
              ificationvis: false,
              infoTable: [],
              page:{
                  pagingTotal: 0,
                  currentVal: 1,
                  pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30')
              },
              detailTable: [], // detailTable table
              detailHeader: {}
          }
      },
      created(){
          this.info()
      },
      methods:{
          tableChangePage(current){
              this.page.currentVal = current
              this.info()
          },
          onShowSizeChange(current, pageSize){
              this.page.currentVal = current
              this.page.pagingSize = pagingSize
              this.info()
          },
          info(){
            this.loading = true
            let params = {
                pageNum: this.page.currentVal,
                pageSize: this.page.pagingSize
            }
            ajax.get(api.INFEOTABLEMSG,params).then(res=>{
                this.loading = false
                if(res.code == 200){
                    this.infoTable = res.data.content
                    this.page.pagingTotal = res.data.totalElements
                }
            })
          },
          cellClickEvent({row}){
              ajax.get(api.MSGCONTENT,{uid: row.uid}).then(res=>{
                  this.detailTable = res.data.msgUserList
                  this.detailHeader = res.data.msg
                  this.ificationvis = true
                  if(this.detailTable.length > 0){
                    for(let ii in this.detailTable){
                        if(this.detailTable[ii].readTime != null){
                            this.detailTable[ii].readTime = moment(this.detailTable[ii].readTime).format("YYYY-MM-DD HH:mm:ss");
                        }
                    }
                  }
              })
          }
      }
  }
</script>
<style lang="less">
  .infoHeader{
    background: #e6f7ff;
    font-size:14px;
    padding:10px;
  }
  .infoDetail{
   .infoDetail_L {
     font-size: 14px;
     color: rgba(0, 0, 0, 0.85);
   }
   .infoDetail_R{
     margin-left:2px;
     font-size: 14px;
   }
  }
  .infodetailContext{
    font-size: 14px;
    height: 15vh;
    overflow: hidden;
    overflow-y:auto;
  }
</style>
